// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___jEHK","comment":"styles_comment__Vy8Oc"};